export default "__VITE_ASSET__Bg$TLRXq__"